export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9381.bd588ef4.jpg";